import { Component, OnInit } from '@angular/core';
import {PaymentDetailsInterface} from '../../../models/payment-details.interface';
import {ConstsHelper} from '../../../../../helpers/consts.helper';
import {UpdateSelectedProcedure} from '../../../store/actions/selected-procedure.actions';
import {Store} from '@ngrx/store';
import {LocalStoragePaymentInterface} from '../../../models/Local-storage-payment.interface';
import {CryptService} from '../../../services/crypt.service';
import {CustomerInterface} from '../../../../account/models/customer.interface';
import {CustomerStorageService} from '../../../../account/services/customer-storage.service';

@Component({
  selector: 'app-credit-account',
  templateUrl: './credit-account.component.html',
  styleUrls: ['./credit-account.component.css'],
  standalone: false
})
export class CreditAccountComponent implements OnInit {

  step: number;
  invalidAmount: boolean;
  localStoragePaymentKey: string;
  paymentDetailsInterface = {
    redirectLink: null,
    externalId: null,
    errorMessage: ConstsHelper.ERROR_MESSAGE_CREDIT_ACCOUNT,
    procedureCode: ConstsHelper.PROCEDURE_CREDIT_MY_ACCOUNT,
    type: 'credit_compte',
    procedureType: 'payment',
    selectedLine: null,
    payload: {},
    amount: 1,
  } as PaymentDetailsInterface;
  customer: CustomerInterface|null;
  maxAmount = 200;

  constructor(
      private store: Store<any>,
      private customerStorageService: CustomerStorageService,
      private cryptService: CryptService
  ) {}

  ngOnInit() {
    this.step = 1;
    this.invalidAmount = false;
    this.localStoragePaymentKey = 'local_storage_payment_' + this.paymentDetailsInterface.type;
    if (localStorage.getItem(this.localStoragePaymentKey)) {
      const localStoragePayment = JSON.parse(this.cryptService.decrypt(localStorage.getItem(this.localStoragePaymentKey))) as LocalStoragePaymentInterface;
      this.paymentDetailsInterface.amount = localStoragePayment.paymentDetails.amount;
      this.setStep(2);
    }
  
    /**
     * change payment threshold according to customer status (res/pro)
     */
    this.customer = this.customerStorageService.getCustomer();
    if (this.customer && this.customer.siret !== '') {
      this.maxAmount = 2000;
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number) {
    this.invalidAmount = false;
    if (Number(this.paymentDetailsInterface.amount) >= 1 && Number(this.paymentDetailsInterface.amount) <= this.maxAmount) {
      this.step = step;
    } else {
      this.invalidAmount = true;
    }
  }

}
